var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{class:{ 'px-3': _vm.small }},[(_vm.right)?_c('v-spacer'):_vm._e(),_c('hr',{staticStyle:{"border":"1px solid black"},style:({ width: _vm.mWidth })})],1)}
var staticRenderFns = []

export { render, staticRenderFns }